<template>
  <div class="home">

   <progressDialog v-bind:loadingContent="loadingContent" />

   <v-data-table
      :headers="headers"
      :items="rules"
      class="elevation-1"
      show-expand
      :footer-props="{
        'items-per-page-options': [15]
      }"
      loading-text="Carregando"
      :loading="loadingSearchData"
      :options.sync="searchPagination"
      :server-items-length.sync="searchPagination.totalItems"
      @update:page="searchDataTableUpdatePage"
    >
      <template v-slot:top>
        <v-toolbar flat color="muted">
          <v-btn icon color="primary" v-on:click="goBack">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-toolbar-title>Regras do Drive</v-toolbar-title>
          <v-spacer></v-spacer>

          <v-select :no-data-text="noDataAvailable" label="Grupo" v-model="ruleGroup" :items="ruleGroups" class="mt-5 pt-1" @change="loadRulesPage" item-text="name" item-value="id">
          </v-select>
          <v-spacer></v-spacer>

          <v-text-field
          v-model="searchTerm"
          append-icon="mdi-card-text"
          label="Pesquise pela descrição ou path"
          single-line
          hide-details
          @keyup="searchTermChange"
          ></v-text-field>

          <v-btn icon color="primary" v-on:click="newItem">
            <v-icon>mdi-plus</v-icon>
          </v-btn>

          <DialogItem ref="dialogItem" v-bind:allTypeRules="allTypeRules"
            v-bind:ruleGroups="ruleGroups"
            v-bind:user-role="userRole"
            v-bind:open="openDialogItem"
            v-bind:editedItem="editedItem"
            v-bind:editing="editing"
            v-on:closeDialogItem="closeDialogItem"
            v-on:saveDialogItem="saveDialogItem" />

        </v-toolbar>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td class="tdexpand" :colspan="headers.length">
            <label v-if="item.ruleDriveGroup.userRole == 'BACKOFFICE'">
              {{ item.accessJson }}
            </label>
            <tableRuleConfigs v-bind:rule="item" v-bind:viewOnly="true" v-else />
        </td>
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="actions">
          <v-icon small class="mr-2"
            @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small class="mr-2"
            @click="deleteItem(item)">
            mdi-trash-can
          </v-icon>
          <v-icon small class="mr-2"
            @click="sortItem(item)">
            mdi-order-numeric-ascending
          </v-icon>
        </div>
      </template>
      <template v-slot:item.typeRule="{ item }">
        {{getTypeRuleDescription(item.typeRule)}}
      </template>
      <template v-slot:item.permission="{ item }">
        <onOffItem v-bind:value="item.permission" />
      </template>
      <template v-slot:item.upload="{ item }">
        <onOffItem v-bind:value="item.upload" />
      </template>
      <template v-slot:item.rename="{ item }">
        <onOffItem v-bind:value="item.rename" />
      </template>
      <template v-slot:item.add="{ item }">
        <onOffItem v-bind:value="item.add" />
      </template>
      <template v-slot:item.delete="{ item }">
        <onOffItem v-bind:value="item.delete" />
      </template>
      <template v-slot:item.active="{ item }">
        <onOffItem v-bind:value="item.active" />
      </template>
      <template v-slot:no-data>
        <span v-show="!loadingContent && !loadingError">Não há regras cadastradas</span>
        <span v-show="loadingError">Ocorreu um erro ao buscar as informações</span>
      </template>
    </v-data-table>

    <DialogNewSortValue v-bind:open="openDialogNewSort" v-bind:selectedItemSort="selectedItemSort"
            v-on:closeNewSortValue="closeNewSortValue"
            v-on:confirmNewSortValue="confirmNewSortValue" />

    <DeletionConfirmationModal :open="deleting" :item="deletedItem" @close="stopDeletingItem" @confirm="confirmItemDeletion"/>

  </div>
</template>
<script>
import tableRuleConfigs from '@/components/table-rule-configs/index.vue';
import onOffItem from '@/components/on-off-item/index.vue';
import progressDialog from '@/components/progress-dialog/progressDialog.vue';
import DeletionConfirmationModal from '@/components/deletion-confirmation-modal/index.vue';
import DialogItem from './DialogItem.vue';
import DialogNewSortValue from './DialogNewSortValue.vue';
import RulesService from '../../service/RulesService';

export default {
  name: 'Rules',
  components: {
    DialogItem,
    DialogNewSortValue,
    tableRuleConfigs,
    onOffItem,
    progressDialog,
    DeletionConfirmationModal,
  },
  props: {
    userRole: String,
    groupId: Number,
  },
  data: () => ({
    content: [],
    loadingContent: false,
    loadingError: false,
    headers: [
      { text: '', sortable: false, value: 'actions' },
      { text: 'Ordem', sortable: false, value: 'sort' },
      { text: 'Descrição', sortable: false, value: 'description' },
      { text: 'Path', sortable: false, value: 'path' },
      { text: 'Tipo', sortable: false, value: 'typeRule' },
      { text: 'Permissão', sortable: false, value: 'permission' },
      { text: 'Upload', sortable: false, value: 'upload' },
      { text: 'Renomear', sortable: false, value: 'rename' },
      { text: 'Criar', sortable: false, value: 'add' },
      { text: 'Excluir', sortable: false, value: 'delete' },
      { text: 'Ativa', sortable: false, value: 'active' },
    ],
    rules: [],
    ruleGroup: 0,
    ruleGroups: [],
    allTypeRules: [
      { id: 'PROFILE', value: 'Perfil' },
      { id: 'USER', value: 'Usuário' },
      { id: 'USER_GROUP', value: 'Grupo' },
    ],
    loadingSearchData: false,
    searchPagination: {
      page: 1,
      rowsPerPage: 15,
      totalItems: 0,
    },
    searchTerm: '',

    openDialogItem: false,
    editedItem: {},
    editing: false,
    openDialogNewSort: false,
    selectedItemSort: {},
    deletedItem: {},
    deleting: false,
    noDataAvailable: 'Nenhum dado encontrado',
  }),

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      await this.loadRuleGroups();
      this.loadRulesPage();
    },
    async loadRuleGroups() {
      this.loadingSearchData = true;
      this.loadingError = false;
      await RulesService.findAllRuleGroups()
        .then((response) => {
          this.loadingSearchData = false;
          // eslint-disable-next-line eqeqeq
          const selectedGroup = response.data.find((group) => group.id == this.groupId);
          this.ruleGroup = selectedGroup.id;
          // eslint-disable-next-line eqeqeq
          response.data.filter((group) => group.userRole == selectedGroup.userRole).forEach((element) => {
            this.ruleGroups.push({
              id: element.id,
              name: element.name,
            });
          });
          this.loadingError = false;
        })
        .catch((error) => {
          this.loadingContent = false;
          this.showMessageErro(error.response.data);
          this.loadingError = true;
        });
    },
    loadRulesPage(newPage) {
      if (newPage) {
        this.searchPagination.page = newPage;
      }

      this.loadingSearchData = true;
      this.loadingError = false;

      const paramsPage = new URLSearchParams();
      paramsPage.append('page', this.searchPagination.page - 1);
      paramsPage.append('size', this.searchPagination.rowsPerPage);
      paramsPage.append('sort', 'sort');

      RulesService.findRulesByTermAndGroup(this.searchTerm, this.ruleGroup, paramsPage)
        .then((response) => {
          this.loadingSearchData = false;
          this.rules = response.data.content;
          this.searchPagination.totalItems = response.data.totalElements;

          this.loadingError = false;
        })
        .catch(() => {
          this.loadingContent = false;
          this.showMessageErro('Ocorreu um erro ao buscar os registros');
          this.rules = [];
          this.loadingError = true;
        });
    },

    searchDataTableUpdatePage() {
      this.loadRulesPage();
    },

    searchTermChange() {
      const actualValueTerm = this.searchTerm;
      const delay = (ms) => new Promise((res) => setTimeout(res, ms));
      const loadBeforeSeconds = async (term, self) => {
        await delay(4000);
        if (term === self.searchTerm) {
          self.loadRulesPage(1);
        }
      };
      loadBeforeSeconds(actualValueTerm, this);
    },

    goBack() {
      this.$router.go(-1);
    },

    newItem() {
      this.editedItem = {
        permission: false,
        active: true,
        upload: false,
        add: false,
        rename: false,
        delete: false,
        ruleDriveGroup: {
          id: this.ruleGroup,
        },
        ruleConfigs: [],
      };
      this.openDialogItem = true;
      this.editing = false;
    },

    editItem(item) {
      this.editedItem = item;
      this.openDialogItem = true;
      this.editing = true;
    },

    sortItem(item) {
      this.selectedItemSort = item;
      this.openDialogNewSort = true;
    },

    deleteItem(item) {
      this.deletedItem = item;
      this.deleting = true;
    },

    stopDeletingItem() {
      this.deleting = false;
      this.deletedItem = {};
    },

    confirmItemDeletion(item) {
      this.deleting = false;
      this.loadingContent = true;
      RulesService.delete(item)
        .then(() => {
          this.loadingContent = false;
          this.loadRulesPage(1);
        })
        .catch(() => {
          this.showMessageErro('Ocorreu um erro ao excluir o registro');
          this.loadingContent = false;
        });
    },

    closeDialogItem() {
      this.openDialogItem = false;
      this.editedItem = {
        permission: false,
        active: true,
        upload: false,
        add: false,
        rename: false,
        delete: false,
        ruleDriveGroup: {
          id: this.ruleGroup,
        },
        ruleConfigs: [],
      };
    },

    saveDialogItem(saved) {
      this.loadingContent = true;
      if (this.editing) {
        RulesService.update(saved)
          .then(() => {
            this.openDialogItem = false;
            this.loadingContent = false;
            this.loadRulesPage(1);
          })
          .catch(() => {
            this.showMessageErro('Ocorreu um erro ao salvar o registro');
            this.loadingContent = false;
          });
      } else {
        RulesService.create(saved)
          .then(() => {
            this.openDialogItem = false;
            this.loadingContent = false;
            this.loadRulesPage(1);
          })
          .catch(() => {
            this.showMessageErro('Ocorreu um erro ao inserir o registro');
            this.loadingContent = false;
          });
      }
    },

    closeNewSortValue() {
      this.selectedItemSort = {};
      this.openDialogNewSort = false;
    },

    confirmNewSortValue(selectedItemSort, newSortValue) {
      this.loadingContent = true;
      RulesService.changeSort(selectedItemSort.id, newSortValue)
        .then(() => {
          this.selectedItemSort = {};
          this.openDialogNewSort = false;
          this.loadingContent = false;
          this.loadRulesPage(1);
        })
        .catch(() => {
          this.showMessageErro('Ocorreu um erro ao alterar os registros');
          this.loadingContent = false;
        });
    },

    getTypeRuleDescription(typeRule) {
      let ruleDescription = '';
      this.allTypeRules.forEach((tr) => {
        if (tr.id === typeRule) {
          ruleDescription = tr.value;
        }
      });
      return ruleDescription;
    },
    showMessageErro(message) {
      this.flash(message, 'error', { timeout: 5000 });
    },
  },
};
</script>
<style scoped>
  .tdexpand {
    padding: 10px;
    box-shadow: none;
  }
  .actions {
    display: flex;
  }
</style>
